import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { DescriptionType, FormControls, Language, MessageLength, MessageStyle } from './community-ai.enum';
import { CommunityService } from '../community.service';
import { Subscription } from 'rxjs';
import { CreateDescriptionDto, DescriptionGenerated } from './community-ai.model';

@Component({
  selector: 'app-community-description-ai',
  templateUrl: './community-description-ai.component.html',
  styleUrls: ['./community-description-ai.component.scss'],
})
export class CommunityDescriptionAiComponent implements OnInit, OnDestroy {

  // Form group to hold the form controls
  form: FormGroup;

  // Array to hold generated messages
  messages: DescriptionGenerated[] = [];

  // #region Enums
  // Enum for form controls
  FormControls = FormControls;
  // Enum for languages
  Language = Language;
  // Enum for message length
  MessageLength = MessageLength;
  // Enum for message style
  MessageStyle = MessageStyle
  // Enum for description type
  DescriptionType = DescriptionType;
  // #endregion

  // #region Boolean
  isToastOpen: boolean = false;
  generatedDescription: boolean = false;
  // #endregion

  // Header text for the modal
  headerText: string = this.translate.instant("COMMUNITY.AI.HEADER_TITLE");

  // Subscription to handle multiple subscriptions
  subscription: Subscription = new Subscription();

  constructor(
    public translate: TranslateService,
    public communitServ: CommunityService,
    private modalCtrl: ModalController,
  ) { }

  ngOnInit() {
    this.initForm();
  }

  back() {
    this.modalCtrl.dismiss(true, "backdrop");
  }

  setOpen(isOpen: boolean) {
    this.isToastOpen = isOpen;
  }

  // send request to AI service
  onSubmit() {
    // Mark all controls as touched to show validation errors
    this.form.markAllAsTouched();

    // Check if the form is valid
    if (this.form.invalid) {
      // If the form is invalid, set the toast open state to true
      this.setOpen(true);
      return
    };

    // If the form is valid, proceed with generating the description
    const data: CreateDescriptionDto = this.form.value as CreateDescriptionDto;

    // Log the data being sent to the AI service
    this.generatedDescription = true;
    
    // Subscribe to the AI service to generate the description
    this.subscription.add(
      // Call the generateDescription method from the community service
      this.communitServ.generateDescription(data).subscribe({
        next: (response: DescriptionGenerated[]) => {
          this.messages = response;
        },
        error: (error) => {
          this.generatedDescription = false;
        },
        complete: () => {
          this.generatedDescription = false;
        }
      })
    );

  }

  // Method to select a generated message
  selectMessage(message: DescriptionGenerated) { 
    this.modalCtrl.dismiss({
      message: message.message,
    });
  }

    // Initialize the form with controls and validators
  private initForm() { 
    this.form = new FormGroup({
      [FormControls.TYPE]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      [FormControls.STYLE]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      [FormControls.LENGTH]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      [FormControls.EMOJIS]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      [FormControls.LANGUAGE]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      [FormControls.MAIN_INFORMATION]: new FormControl(null, {
        validators: [Validators.required],
        updateOn: 'change'
      })
    });
  }

  ngOnDestroy() { 
    this.subscription?.unsubscribe();
  }

}
